import { SpendTypeEnum } from 'components/Classification';
import { PERMISSIONS } from 'utils/constants';

export const ROOT_ROUTE = '/allocation';

export const CONFIG = [
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.THIRD_PARTY}`,
    name: SpendTypeEnum.THIRD_PARTY,
  },
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.PERSONNEL}`,
    name: SpendTypeEnum.PERSONNEL,
    permission: PERMISSIONS.APPLICATIONS_DATA_ALLOCATE,
  },
];
